import { Component, inject, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ITab, TabsComponent } from '@tecalisdev/infinity';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { ITextLocaleMap } from '../../../operations/models/operations.models';

@Component({
	selector: 'app-text-locale-preview',
	imports: [TabsComponent, SafeHtmlPipe],
	templateUrl: './text-locale-preview.component.html',
	styleUrl: './text-locale-preview.component.scss',
})
export class TextLocalePreviewComponent implements OnChanges {
	private readonly translate = inject(TranslateService);

	@Input() textLocale: ITextLocaleMap | string | null = null;

	public tabs: ITab[] = [];
	public selectedLang = '';

	public ngOnChanges(): void {
		try {
			this.rebuildTabs();
		} catch {
			this.tabs = [];
			this.selectedLang = '';
		}
	}

	/** HTML legacy: un solo string, sin pestañas. */
	public isPlainStringHtml(): boolean {
		return typeof this.textLocale === 'string';
	}

	public get plainHtmlString(): string {
		return typeof this.textLocale === 'string' ? this.textLocale : '';
	}

	public get selectedObjectHtml(): string {
		if (this.textLocale == null || typeof this.textLocale !== 'object' || Array.isArray(this.textLocale)) {
			return '';
		}
		const record = this.textLocale as ITextLocaleMap;
		return record[this.selectedLang] ?? '';
	}

	public onTabSelected(tab: { id: string }): void {
		if (!tab?.id) {
			return;
		}
		this.selectedLang = tab.id;
		this.tabs = this.tabs.map((t) => ({ ...t, selected: t.id === tab.id }));
	}

	private rebuildTabs(): void {
		if (this.textLocale == null || typeof this.textLocale === 'string' || Array.isArray(this.textLocale)) {
			this.tabs = [];
			this.selectedLang = '';
			return;
		}

		const keys = Object.keys(this.textLocale);
		this.selectedLang = keys[0] ?? '';
		this.tabs = keys.map((key, index) => ({
			id: key,
			label: this.tabLabelForKey(key),
			selected: index === 0,
		}));
	}

	private tabLabelForKey(key: string): string {
		const upper = key.toUpperCase();
		const translated = this.translate.instant(`TEXT_LOCALE.LANG.${upper}`);
		return translated && translated !== `TEXT_LOCALE.LANG.${upper}` ? translated : upper;
	}
}
